import React, { useState, useEffect } from "react";
import { app, FrameContexts } from "@microsoft/teams-js";
import { useNavigate } from "react-router-dom";
import { Button, FluentProvider, webLightTheme } from '@fluentui/react-components';
import { CustomDropdown } from '../components/CustomDropdown';
import { fetchSmartFormTemplates } from '../services/SurveyService';
import "../styles/TranscriptConsent.scss";

const FormSelectionScene = () => {
  const [ready, setReady] = useState(false);
  const [selectedForm, setSelectedForm] = useState(0);
  const [formOptions, setFormOptions] = useState<{ value: string; label: string }[]>([]);

  const navigate = useNavigate();

  useEffect(() => {
    const initializeApp = async () => {
      await app.initialize();
      try {
        const context = await app.getContext();

        if (context.page.frameContext !== FrameContexts.sidePanel) {
          setReady(false);
          return;
        }

        setReady(true);
      } catch (error) {
        setReady(false);
      }
    };

    const loadFormOptions = async () => {
      try {
        const templates = await fetchSmartFormTemplates();
        const options = templates.map((template: { id: number; name: string }) => ({ value: template.id, label: template.name }));
        setFormOptions(options);
      } catch (error) {
        console.error("Failed to load form options", error);
      }
    };

    initializeApp();
    loadFormOptions();
  }, []);

  if (!ready) {
    return (
      <div style={{ padding: "16px" }}>
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <FluentProvider theme={webLightTheme}>
      <div style={{ display: "flex", flexDirection: "column", height: "90vh", padding: "16px" }}>
        <div>
          <Button appearance="subtle" icon={<span style={{display:'inline-block',transform:'rotate(180deg)'}}>&#8594;</span>} onClick={() => navigate(-1)} aria-label="Back" />
        </div>

        <div style={{ marginTop: "16px" }}>
          <h4>Health Partners Transcript Assistant</h4>
          <p>ACAB/MR/25/9043</p>
        </div>

        <div style={{ marginTop: "24px" }}>
          <CustomDropdown
            label="Select Clinical Form"
            options={formOptions}
            value={selectedForm.toString()}
            onChange={e => setSelectedForm(Number(e.target.value))}
            placeholder="Select a form"
          />
        </div>

        <div style={{ flexGrow: 1 }}></div>

        <div style={{ marginBottom: "10px", display: "flex", justifyContent: "center" }}>
          <Button 
            appearance="primary" 
            onClick={() => navigate(`/observationForm`, { state: { selectedForm } })} 
            style={{ backgroundColor: "#6264A7", color: "#fff" }}
          >
            OK
          </Button >
        </div>
      </div>
    </FluentProvider>
  );
};

export default FormSelectionScene;
